import { Slide } from '@mui/material';
import { Box } from '@mui/system';
import React, { CSSProperties, FC } from 'react';
import { IProps } from 'types/common';
import { IWizardActionsButtonsProps, IWizardProps } from 'types/wizard';
import WizardActionsButtons from '../components/WizardActionButtons';

interface IWizardContentLayoutProps
	extends IWizardProps,
		IProps,
		IWizardActionsButtonsProps {
	slideStyle?: CSSProperties | undefined;
}

const WizardContentLayout: FC<IWizardContentLayoutProps> = ({
	children,
	...props
}) => {
	const { state, slideStyle } = props;
	const { page } = state;
	const [entered, setEntered] = React.useState(true);

	React.useEffect(() => {
		setEntered(false);
		setTimeout(() => {
			setEntered(true);
		}, 100);
	}, [page]);

	return (
		<Box
			data-testid="wizard-content-layout"
			display="flex"
			flexGrow={1}
			flexDirection="column"
			justifyContent="space-between"
		>
			<Slide direction="left" in={entered} style={slideStyle}>
				<Box
					data-testid="wizard-content-layout"
					px={{
						xs: 1,
						sm: 2
					}}
				>
					{entered && children}
				</Box>
			</Slide>
			<Box
				display={{
					xs: 'flex-end',
					sm: 'flex'
				}}
				justifyContent="flex-end"
				data-testid="wizard-content-layout-actions"
				pr={{
					xs: 2,
					sm: 6
				}}
				pt={1}
				pb={2}
			>
				<WizardActionsButtons {...props} />
			</Box>
		</Box>
	);
};

WizardContentLayout.defaultProps = {
	slideStyle: { display: 'flex' }
};

export default WizardContentLayout;
